var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{style:('border: 1px solid '+_vm.cardColor+';'),attrs:{"outlined":"","rounded":"lg"}},[_c('v-card-title',{style:('color:'+_vm.cardColor+'')},[_vm._v(_vm._s(_vm.cardData.title))]),_c('v-card-actions',{style:('color:'+_vm.cardColor+'')},[_vm._v(" "+_vm._s(_vm.cardData.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }